<template>
    <div class="phonemes-form">
        <button class="button phonemes-form__add" @click="open">
            <IconPlus />
        </button>
        <portal to="modals">
            <PhonemeModal
                v-if="opened"
                :phonemes="phonemes"
                show-source-word
                show-speakers
                @saved="savePhoneme"
                @close="close"
                @selectSpeaker="selectSpeaker"
            />
        </portal>
    </div>
</template>

<script>
import { IconPlus } from '@speechki-frontend/shared/ui/icons';
import PhonemeModal from '../SsmlPhonemeControl/PhonemeModal';
import { mapGetters, mapState, mapActions } from 'vuex';

import { fetchPhonemes, savePhoneme } from '../../api/phonemes';

export default {
    name: 'PhonemesForm',
    components: {
        PhonemeModal,
        IconPlus
    },
    data() {
        return {
            loading: false,
            opened: false,
            speaker: '',
            initialPhonemes: []
        };
    },
    computed: {
        ...mapGetters(['speakerLanguage']),
        ...mapGetters('ssmlTags', ['availableTags']),
        ...mapState('ssmlTags', {
            ssmlTags: state => state.ssmlTags
        }),
        phonemes() {
            if (!Object.values(this.ssmlTags).length) return this.initialPhonemes;
            const speakerLanguage = this.speakerLanguage(this.speaker);
            return this.ssmlTags.phoneme.attribute.ph.refs[speakerLanguage];
        }
    },
    async created() {
        this.loading = true;
        try {
            await Promise.all([this.fetchPhonemes()]);
        } catch (err) {
            console.log(err);
        } finally {
            this.loading = false;
        }
    },
    methods: {
        ...mapActions('ssmlTags', ['fetchSsmlTags']),
        async fetchPhonemes() {
            const params = { page_size: 999 };
            const { results } = await fetchPhonemes(params);
            this.initialPhonemes = results;
        },
        open() {
            this.opened = true;
        },
        close() {
            this.opened = false;
        },
        async savePhoneme({ key, phoneme: value, speaker }) {
            try {
                await savePhoneme({
                    key,
                    value,
                    speaker
                });
                this.close();
                this.$emit('saved');
            } catch (err) {
                console.log(err);
            }
        },
        async selectSpeaker(slug) {
            this.loading = true;
            try {
                this.speaker = slug;
                await this.fetchSsmlTags(slug);
            } catch (err) {
                console.log(err);
            } finally {
                this.loading = false;
            }
        }
    }
};
</script>

<style src="./PhonemesForm.scss" lang="scss"></style>
